export const ACTIVATION_TASK_STATUS_COMPLETE = 'complete';
export const ACTIVATION_TASK_STATUS_INCOMPLETE = 'incomplete';
export const ACTIVATION_TASK_STATUS_EVERGREEN = 'evergreen';
export const ACTIVATION_TASK_STATUS_LABELS = {
    [ACTIVATION_TASK_STATUS_COMPLETE]: 'Complete',
    [ACTIVATION_TASK_STATUS_INCOMPLETE]: 'Incomplete',
    [ACTIVATION_TASK_STATUS_EVERGREEN]: 'Ongoing'
};
export const ACTIVATION_TYPE_CUSTOM = 'custom';
export const ACTIVATION_DELIVERY_METHOD_FILE = 'file';
export const ACTIVATION_DELIVERY_METHOD_TEXT = 'text';
export const ACTIVATION_DELIVERY_METHOD_URL = 'url';
export const ACTIVATION_DELIVERY_METHOD_NONE = 'none';
export const ACTIVATION_DELIVERY_METHOD_LABEL_MAP = {
    [ACTIVATION_DELIVERY_METHOD_FILE]: 'File Upload',
    [ACTIVATION_DELIVERY_METHOD_URL]: 'URL',
    [ACTIVATION_DELIVERY_METHOD_TEXT]: 'Text',
    [ACTIVATION_DELIVERY_METHOD_NONE]: 'N/A'
};
export const ACTIVATION_CUSTOM_TASK_ICONS = [
    {
        name: 'snapchat',
        type: 'brand',
        icon: 'fab fa-snapchat'
    },
    {
        name: 'blogger',
        type: 'brand',
        icon: 'fab fa-blogger'
    },
    {
        name: 'amazon',
        type: 'brand',
        icon: 'fab fa-amazon'
    },
    {
        name: 'yelp',
        type: 'brand',
        icon: 'fab fa-yelp'
    },
    {
        name: 'thumbs-up',
        type: 'regular',
        icon: 'thumbs-up'
    },
    {
        name: 'heart',
        type: 'regular',
        icon: 'heart'
    },
    {
        name: 'pen-alt',
        type: 'regular',
        icon: 'pen-alt'
    },
    {
        name: 'paperclip',
        type: 'regular',
        icon: 'paperclip'
    },
    {
        name: 'gift',
        type: 'regular',
        icon: 'gift'
    },
    {
        name: 'globe',
        type: 'regular',
        icon: 'globe'
    },
    {
        name: 'quote-right',
        type: 'regular',
        icon: 'quote-right'
    },
    {
        name: 'comment-alt-lines',
        type: 'regular',
        icon: 'comment-alt-lines'
    },
    {
        name: 'envelope',
        type: 'regular',
        icon: 'envelope'
    },
    {
        name: 'file-signature',
        type: 'regular',
        icon: 'file-signature'
    },
    {
        name: 'file-alt',
        type: 'regular',
        icon: 'file-alt'
    },
    {
        name: 'tag',
        type: 'regular',
        icon: 'tag'
    },
    {
        name: 'asterisk',
        type: 'regular',
        icon: 'asterisk'
    },
    {
        name: 'photo-video',
        type: 'regular',
        icon: 'photo-video'
    },
    {
        name: 'camera',
        type: 'regular',
        icon: 'camera'
    },
    {
        name: 'video',
        type: 'regular',
        icon: 'video'
    }
];
